// Prof. Scaly (小甲教授) — shared mascot metadata & helper.
export const MASCOT = {
  cn: "小甲教授",
  en: "Prof. Scaly",
  role_cn: "英语向导",
  role_en: "Your English guide",
  img: "https://customer-assets.emergentagent.com/job_bilingual-exam-coach/artifacts/2v92mm2i_file_00000000b8947207b6be688fc35a0ba2.png",
  tagline_cn: "让我们一起学英文吧！",
  tagline_en: "Let's learn English together!",
};

export default MASCOT;
